import React, { useEffect, useState } from 'react';
import { supabase } from '../client/client';
import { prepararCuerpo } from '../utils/texto';

const Editorial = () => {
  const [editorial, setEditorial] = useState(null);

  useEffect(() => {
    const fetchNewsData = async () => {
      const { data, error } = await supabase
        .from('editorial')
        .select('*')
        .order('created_at', { ascending: false })
        .limit(1)
        .maybeSingle();

      if (!error) {
        setEditorial(data);
      } else {
        console.error("Error fetching editorial:", error);
      }
    };

    fetchNewsData();
  }, []);




  return (
    <>
      {editorial ? (
        <div className="ed-shell ed-pagina">
          <header className="ed-pagina__cabecera">
            <p className="ed-kicker">Editorial</p>
            <h1 className="ed-pagina__titulo">{editorial.title}</h1>
            <p className="ed-byline">
              <strong>{editorial.written_by}</strong>
              {editorial.charge ? ` · ${editorial.charge}` : ''}
            </p>
          </header>

          <div className="ed-editorial">
            <figure className="ed-editorial__retrato">
              <img src={editorial.image_url} alt={editorial.written_by} loading="lazy" decoding="async" />
              <figcaption className="ed-caption">{editorial.written_by}</figcaption>
            </figure>

            <div
              className="editorial-body"
              dangerouslySetInnerHTML={{ __html: prepararCuerpo(editorial.body) }}
            ></div>
          </div>
        </div>
      ) : (
        <p>Cargando editorial...</p>
      )}
    </>
  )
}

export default Editorial
